import { render, staticRenderFns } from "./ManagerContractorRequest.vue?vue&type=template&id=35b748a4"
import script from "./ManagerContractorRequest.vue?vue&type=script&lang=ts"
export * from "./ManagerContractorRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b748a4')) {
      api.createRecord('35b748a4', component.options)
    } else {
      api.reload('35b748a4', component.options)
    }
    module.hot.accept("./ManagerContractorRequest.vue?vue&type=template&id=35b748a4", function () {
      api.rerender('35b748a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ManagerContractorRequest.vue"
export default component.exports